<template>
  <div class="part4" id="if2021-partner">
    <img
      class="partner-list-title"
      src="https://summit-img.geekpark.net/if2021/pc/04-合作伙伴-pc.svg"
    />
    <img
      class="partner-list"
      src="https://summit-img.geekpark.net/if2021/pc/合作伙伴-PC-2.svg"
    />
  </div>
</template>

<script>
export default {
  name: "Part4",
};
</script>

<style lang="less" scoped>
.part4 {
  text-align: center;
  margin-left: -8vh;
  background: #f3f3f3
    url("https://summit-img.geekpark.net/if2021/pc/合作伙伴背景.svg") no-repeat
    center center / cover;
  .partner-list-title {
    width: 164vh;
    height: auto;
  }
  .partner-list {
    width: 116vh;
    height: auto;
  }
}
</style>